import ReactDOM from 'react-dom/client'
import { App } from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { UserContextProvider } from 'context/UserContext'
import axios from 'axios'
import { decodeJWT } from 'helpers/jwtDecode'
import moment from 'moment'

/* eslint-disable @typescript-eslint/no-empty-function */
axios.interceptors.request.use(
  function (config) {
    const user = localStorage.getItem('user')
    const token = user ? JSON.parse(user).token : null
    if (token) {
      config.headers.Authorization = token ? 'Bearer ' + token : null
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const fetchDecodeRoles: any = decodeJWT(token)
      if (fetchDecodeRoles.exp <= moment().unix()) {
        localStorage.removeItem('user')
        location.reload()
        throw new Error('Authorization failed, invalid credentials')
      }
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem('user')
      location.reload()
      // dispatch({ type: UserTypes.SIGN_OUT })
    }
    return Promise.reject(error)
  },
)
/* eslint-enable @typescript-eslint/no-empty-function */

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <BrowserRouter>
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </BrowserRouter>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
